import { render, staticRenderFns } from "./debito_credito.vue?vue&type=template&id=0fb0af86"
import script from "./debito_credito.vue?vue&type=script&lang=js"
export * from "./debito_credito.vue?vue&type=script&lang=js"
import style0 from "./debito_credito.vue?vue&type=style&index=0&id=0fb0af86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports